import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { AccountConfirmService } from "../../services/account-confirm.service";
import { ConfirmUserAccountViewModel } from "../../models/confirm-user-account-view-model";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder, AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-account-confirm',
  templateUrl: './account-confirm.component.html',
  styleUrls: ['./account-confirm.component.scss']
})
export class AccountConfirmComponent implements OnInit {
  public email: string;
  public password: FormControl;
  public confirmPassword: FormControl;
  private _destroyed$ = new Subject<any>();
  public token: string;
  public submitted = false;

  constructor(private _accountConfirmService: AccountConfirmService, private _router: Router, private route: ActivatedRoute, private _toastService: ToastrService) {
    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      this.token = params.token;
    });

     // this._router.navigate(['/account-confirm'], { queryParams: { token: '323232' } });


  }
  ngOnInit() {
    this.password = new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&])/)]));
    this.confirmPassword = new FormControl('', Validators.compose([Validators.required, this.passwordValidator()]));
  }

  public passwordValidator(): (AbstractControl) => ValidationErrors | null {

    return (control: AbstractControl): ValidationErrors | null => {
      if (!!control.value && control.value === this.password.value) {
        return null;
      }

      return { passwordsMatch: true };
    }

  }

  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  public async confirm(): Promise<void> {
    if (this.password.invalid || this.confirmPassword.invalid) {
      this.password.markAsTouched();
      this.confirmPassword.markAsTouched();
      this.submitted = true;
    } else {
      const confirmed = await this._accountConfirmService.confirm(this.password.value, this.email, this.token);

      if (confirmed.success === true) {

        this._toastService.success(confirmed.message, "Success");
        this._router.navigate(['account/login']);
      } else {
        this._toastService.error(confirmed.message, "Error");
      }
    }

  }

}
